export const downloadSVGElementAction = {
    type: "downloadSVGElement",
    payload: true,
};